// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useForm } from "react-hook-form";
// import { loginUser } from "../../redux/actions/authActions";
// import { useHistory } from "react-router-dom";
// import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
// import mainpic from "./Untitledd.png";
// import "./login.css";

// export default function Login() {
//   const dispatch = useDispatch();
//   const history = useHistory();
//   const { loading, error, isAuthenticated, isAdmin } = useSelector((state) => state.auth);
//   const { handleSubmit } = useForm();
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [formVisible, setFormVisible] = useState(false);

//   const onSubmit = () => {
//     dispatch(loginUser({ email, password }, history));
//   };

//   useEffect(() => {
//     if (isAuthenticated) {
//       if (isAdmin) {
//         history.push("/home");
//       } else {
//         history.push("/selectteam");
//       }
//     }
//   }, [isAuthenticated, isAdmin, history]);

//   return (
//     <div className="login">
//       <div className={`main-icon ${formVisible ? "move-left" : ""}`}>
//         <img src={mainpic} alt="Main Icon" />
//       </div>
//       <div className={`login-box ${formVisible ? "show-form" : ""}`}>
//         <h2 className="heading">Login</h2>
//         <form onSubmit={handleSubmit(onSubmit)}>
//           <div className="user-box">
//             <input
//               type="text"
//               name="email"
//               required
//               onChange={(e) => setEmail(e.target.value)}
//             />
//             <label>Email</label>
//           </div>
//           <div className="user-box">
//             <input
//               type="password"
//               name="password"
//               required
//               onChange={(e) => setPassword(e.target.value)}
//             />
//             <label>Password</label>
//           </div>
//           <div className="container">
//             <button type="submit" disabled={loading}>
//               {loading ? <HourglassBottomIcon /> : <p>Submit</p>}
//             </button>
//           </div>
//           {error && (
//             <p className="error-box">
//               <span className="error-icon">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 24 24"
//                   width="16"
//                   height="16"
//                 >
//                   <path
//                     d="M12.865 3.00017L22.3912 19.5002C22.6674 19.9785 22.5035 20.5901 22.0252 20.8662C21.8732 20.954 21.7008 21.0002 21.5252 21.0002H2.47266C1.92037 21.0002 1.47266 20.5525 1.47266 20.0002C1.47266 19.8246 1.51886 19.6522 1.60663 19.5002L11.1329 3.00017C11.4091 2.52187 12.0206 2.358 12.4989 2.63414C12.651 2.72191 12.7772 2.84815 12.865 3.00017ZM4.20471 19.0002H19.7932L11.9989 5.50017L4.20471 19.0002ZM10.9989 16.0002H12.9989V18.0002H10.9989V16.0002ZM10.9989 9.00017H12.9989V14.0002H10.9989V9.00017Z"
//                     fill="rgba(255,255,255,1)"
//                   ></path>
//                 </svg>{" "}
//               </span>
//               {error}
//             </p>
//           )}
//         </form>
//       </div>
//       {!formVisible && (
//         <button className="show-form-button" onClick={() => setFormVisible(true)}>
//           Login
//         </button>
//       )}
//     </div>
//   );
// }

// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useForm } from "react-hook-form";
// import { loginUser } from "../../redux/actions/authActions";
// import { useHistory } from "react-router-dom";
// import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
// import mainpic from "./Untitledd.png";
// import "./login.css";

// export default function Login() {
//   const dispatch = useDispatch();
//   const history = useHistory();
//   const { loading, error, isAuthenticated } = useSelector((state) => state.auth);
//   const { handleSubmit } = useForm();
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [formVisible, setFormVisible] = useState(false);

//   const onSubmit = (data) => {
//     dispatch(loginUser({ email, password }, history));
//   };

//   useEffect(() => {
//     if (isAuthenticated) {
//       history.push("/home"); // Redirect to homepage upon successful login
//     }
//   }, [isAuthenticated, history]);

//   return (
//     <div className="login">
//       <div className={`main-icon ${formVisible ? "move-left" : ""}`}>
//         <img src={mainpic} alt="Main Icon" />
//       </div>
//       <div className={`login-box ${formVisible ? "show-form" : ""}`}>
//         <h2 className="heading">Login</h2>
//         <form onSubmit={handleSubmit(onSubmit)}>
//           <div className="user-box">
//             <input
//               type="text"
//               name="email"
//               required
//               onChange={(e) => setEmail(e.target.value)}
//             />
//             <label>Email</label>
//           </div>
//           <div className="user-box">
//             <input
//               type="password"
//               name="password"
//               required
//               onChange={(e) => setPassword(e.target.value)}
//             />
//             <label>Password</label>
//           </div>
//           <div className="container">
//             <button type="submit" disabled={loading}>
//               {loading ? <HourglassBottomIcon /> : <p>Submit</p>}
//             </button>
//           </div>
//           {error && (
//             <p className="error-box">
//               <span className="error-icon">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 24 24"
//                   width="16"
//                   height="16"
//                 >
//                   <path
//                     d="M12.865 3.00017L22.3912 19.5002C22.6674 19.9785 22.5035 20.5901 22.0252 20.8662C21.8732 20.954 21.7008 21.0002 21.5252 21.0002H2.47266C1.92037 21.0002 1.47266 20.5525 1.47266 20.0002C1.47266 19.8246 1.51886 19.6522 1.60663 19.5002L11.1329 3.00017C11.4091 2.52187 12.0206 2.358 12.4989 2.63414C12.651 2.72191 12.7772 2.84815 12.865 3.00017ZM4.20471 19.0002H19.7932L11.9989 5.50017L4.20471 19.0002ZM10.9989 16.0002H12.9989V18.0002H10.9989V16.0002ZM10.9989 9.00017H12.9989V14.0002H10.9989V9.00017Z"
//                     fill="rgba(255,255,255,1)"
//                   ></path>
//                 </svg>{" "}
//               </span>
//               {error}
//             </p>
//           )}
//         </form>
//       </div>
//       {!formVisible && (
//         <button className="show-form-button" onClick={() => setFormVisible(true)}>
//           Login
//         </button>
//       )}
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { loginUserAction } from "../../user/redux/actions/auth.actions.js";
import { useHistory } from "react-router-dom";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";

import mainImg from "../../user/pages/assets/dashboard.png";
import headerImg from "../../user/pages/assets/topHeader.png";

import "./login.css";
export default function Login() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isAuthenticated, isAdmin } = useSelector((state) => state.auth);
  const { handleSubmit } = useForm();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [formVisible, setFormVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = () => {
    dispatch(
      loginUserAction({ email, password }, history, setLoading, setError)
    );
  };

  const handleSignUp = () => {
    history.push('/signup');
  };

  useEffect(() => {
    // Only redirect if actually authenticated
    if (isAuthenticated && !loading) {
      if (isAdmin) {
        history.push("/home");
      } else {
        history.push("/selectteam");
      }
    }
  }, [isAuthenticated, isAdmin, history, loading]);

  return (
    <div className="login">
      <div className="topContent">
        <h1 className="welcomeHeading"> WELCOME! </h1>
        <h2 className="welcomeSubHeading"> LOG-IN HERE </h2>
        <div className="imageBoxMain">
          <img src={mainImg} className="headerImage" alt="Dashboard Header" />
        </div>
      </div>
      <div className="login-box">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="user-box">
            <p style={{ color: "white", fontWeight: "700", marginBottom: "6px" }}>
              Email{" "}
            </p>
            <input
              placeholder="Enter your email"
              type="text"
              name="enter your email"
              required
              onChange={(e) => setEmail(e.target.value)}
              value={email} // Added value attribute to control the input
            />

            <p style={{ color: "white", fontWeight: "700", marginBottom: "6px" }}>
              Password{" "}
            </p>
            <input
              placeholder="Enter your password"
              type="password"
              name="password"
              required
              onChange={(e) => setPassword(e.target.value)}
              value={password} // Added value attribute to control the input
            />
          </div>
          <div className="container" >
            <button type="submit" disabled={loading} style={{ marginRight: '15px' }}>
              {loading ? <HourglassBottomIcon /> : <p>LOGIN</p>}
            </button>
            {/* <button type="button" onClick={handleSignUp} style={{ backgroundColor: 'goldenrod' }}>
              <p>SIGN-UP</p>
            </button> */}
          </div>
              {error && (
                <p className="error-box">
                Incorrect Email or password!!!
                </p>
          )}
        </form>
      </div>
    </div>
  );
}
